import {
  Component, Input,OnChanges, SimpleChanges, ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DxDataGridComponent,
  DxDataGridModule,
  DxLoadPanelModule,
} from 'devextreme-angular';
import dxDataGrid from 'devextreme/ui/data_grid';
import { TranslateModule } from '@ngx-translate/core';
import { Task } from '../../../types/task';

@Component({
  selector: 'card-tasks',
  templateUrl: './card-tasks.component.html',
  styleUrls: ['./card-tasks.component.scss'],
  imports: [
    DxDataGridModule,
    DxLoadPanelModule,
    CommonModule,
    TranslateModule,
  ]
})
export class CardTasksComponent implements OnChanges {
  @ViewChild('dataGrid', { static: false }) component: DxDataGridComponent;

  @Input() tasks: Task[];

  @Input() isLoading: boolean = false;

  currentTasks: Task[];

  constructor() {
    this.onReorder = this.onReorder.bind(this);
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.tasks?.currentValue) {
      this.currentTasks = changes.tasks.currentValue.filter((item) => !!item.status && !!item.priority);
    }
  }

  // El nuevo dxo-data-grid-row-dragging tipa `e.component` como GridBase generico (no
  // dxDataGrid). Como el handler necesita getVisibleRows(), casteamos al tipo concreto.
  onReorder(e: { component: unknown; toIndex: number; itemData: Task }) {
    const grid = e.component as dxDataGrid;
    const visibleRows = grid.getVisibleRows();
    const toIndex = this.currentTasks.indexOf(visibleRows[e.toIndex].data);
    const fromIndex = this.currentTasks.indexOf(e.itemData);

    this.currentTasks.splice(fromIndex, 1);
    this.currentTasks.splice(toIndex, 0, e.itemData);
  }
}
